import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

// Landing page voor `/account/confirm-email?token=xxx` — verifieert de token
// via POST /account/email/confirm en toont het resultaat.
export default function ConfirmEmailPage() {
  const [search] = useSearchParams();
  const token = search.get("token");
  const [status, setStatus] = useState("checking");  // checking|success|failed
  const [message, setMessage] = useState("");
  const [newEmail, setNewEmail] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("failed");
      setMessage("Geen token in de link.");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/account/email/confirm", { token });
        setNewEmail(data.new_email || "");
        setStatus("success");
      } catch (e) {
        setMessage(formatApiError(e.response?.data?.detail) || "Bevestigen mislukt.");
        setStatus("failed");
      }
    })();
  }, [token]);

  return (
    <AppLayout>
      <div className="max-w-md mx-auto mt-8 border-2 border-foreground bg-card heavy-shadow p-8 text-center" data-testid="confirm-email-page">
        {status === "checking" && (
          <>
            <Loader2 className="w-12 h-12 mx-auto animate-spin text-primary" />
            <h1 className="font-display font-black text-2xl uppercase mt-4">Even bevestigen…</h1>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 className="w-12 h-12 mx-auto text-positive" data-testid="confirm-success" />
            <div className="stat-label mt-3 text-positive">Bevestigd</div>
            <h1 className="font-display font-black text-2xl uppercase mt-1">Je e-mailadres is bijgewerkt</h1>
            {newEmail && (
              <p className="text-sm text-muted-foreground mt-3">
                Vanaf nu log je in met <b className="font-mono-num">{newEmail}</b>.
              </p>
            )}
            <Link
              to="/account"
              data-testid="confirm-success-account"
              className="mt-5 inline-block btn-brutal bg-primary text-primary-foreground px-4 py-2 font-display uppercase font-bold text-sm"
            >
              Naar mijn account
            </Link>
          </>
        )}
        {status === "failed" && (
          <>
            <XCircle className="w-12 h-12 mx-auto text-destructive" data-testid="confirm-failed" />
            <h1 className="font-display font-black text-2xl uppercase mt-3">Bevestigen mislukt</h1>
            <p className="text-sm text-muted-foreground mt-3">{message}</p>
            <Link
              to="/account"
              data-testid="confirm-failed-account"
              className="mt-5 inline-block btn-brutal bg-background text-foreground border-2 border-foreground px-4 py-2 font-display uppercase font-bold text-sm"
            >
              Terug naar account
            </Link>
          </>
        )}
      </div>
    </AppLayout>
  );
}
